module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d3-content-container"
  }, [(_vm.index < 0 || !_vm.content || !_vm.content.dataType) ? _c('div', {
    staticClass: "static-contents"
  }, [_vm._m(0)]) : (_vm.content.dataType == 'mp4') ? [_c('mp4-player', {
    attrs: {
      "content": _vm.content
    }
  })] : (_vm.content.dataType == 'mp3') ? [_c('mp3-player', {
    attrs: {
      "content": _vm.content
    }
  })] : (_vm.content.dataType == 'image') ? [_c('image-viewer', {
    attrs: {
      "content": _vm.content
    }
  })] : (_vm.content.dataType == 'pdf') ? [_c('pdf-viewer', {
    attrs: {
      "content": _vm.content
    }
  })] : (_vm.content.dataType == 'dlc_code') ? [_c('dlc-code-viewer', {
    attrs: {
      "content": _vm.content
    }
  })] : (_vm.content.dataType == 'url_link' && _vm.content.data.isInnerFrame) ? [_c('inner-web-viewer', {
    attrs: {
      "content": _vm.content
    }
  })] : (_vm.content.dataType == 'url_link' && _vm.content.data.s3Url) ? [_c('url-link-with-signed-cookie', {
    attrs: {
      "content": _vm.content
    }
  })] : (_vm.content.dataType == 'youtube') ? [_c('youtube-player', {
    attrs: {
      "content": _vm.content
    }
  })] : (_vm.content.dataType == 'questionnaire') ? [_c('questionnaire', {
    attrs: {
      "content": _vm.content
    }
  })] : (_vm.content.dataType == 'mp4_360') ? [_c('mp4-player360', {
    attrs: {
      "content": _vm.content
    }
  })] : [_c('div', {
    staticClass: "d3-content-notfound"
  }, [_c('p', [_vm._v("このコンテンツは対応していません。")])])], _vm._v(" "), _c('button', {
    staticClass: "d3-image-viewer-back mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab",
    class: {
      'mdl-button--primary': _vm.content && _vm.content.dataType == 'questionnaire'
    },
    on: {
      "click": _vm.onClickBack
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_back")])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d3-content-notfound"
  }, [_c('h6', [_vm._v("コンテンツが見つかりませんでした。")]), _vm._v(" "), _c('p', [_vm._v("再度バッジをスキャンしてください。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aab086a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/Content.vue
// module id = 1133
// module chunks = 38